module.exports = __webpack_public_path__ + "img/core-advantages-1.43dd24dc.svg";